import React, { useState } from 'react'
import ClinicAssistantProfileDrawer from './index'

/**
 * Higher-order component to add profile drawer functionality
 * Keeps drawer logic separate from main components
 */
export function withProfileDrawer(Component) {
  return function WithProfileDrawerWrapper(props) {
    const [profileDrawerOpen, setProfileDrawerOpen] = useState(false)
    const { assistantData, clinicId, ...restProps } = props

    const openProfileDrawer = () => setProfileDrawerOpen(true)
    const closeProfileDrawer = () => setProfileDrawerOpen(false)

    return (
      <>
        <Component
          {...restProps}
          onOpenProfileDrawer={openProfileDrawer}
        />
        <ClinicAssistantProfileDrawer
          open={profileDrawerOpen}
          onClose={closeProfileDrawer}
          clinicId={clinicId}
          assistantData={assistantData}
        />
      </>
    )
  }
}

/**
 * Hook to manage profile drawer state
 * Use this in components that need drawer functionality
 */
export function useProfileDrawer() {
  const [isOpen, setIsOpen] = useState(false)

  return {
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
    toggle: () => setIsOpen((prev) => !prev),
  }
}

